import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngx-translate/core";
var SiteLanguageCode;
(function (SiteLanguageCode) {
    SiteLanguageCode["es"] = "es";
    SiteLanguageCode["us"] = "us";
    SiteLanguageCode["en"] = "en";
    SiteLanguageCode["br"] = "br";
})(SiteLanguageCode || (SiteLanguageCode = {}));
;
var defaultSiteLanguage = SiteLanguageCode.br;
var LanguageService = /** @class */ (function () {
    function LanguageService(router, translateService) {
        this.router = router;
        this.translateService = translateService;
    }
    LanguageService.prototype.defineLanguage = function (languageParam) {
        var lang = this.getValidSiteLanguageCode(languageParam);
        localStorage.setItem('lang', lang);
        return lang;
    };
    LanguageService.prototype.getValidSiteLanguageCode = function (languageCode) {
        switch (languageCode) {
            case SiteLanguageCode.es:
                return SiteLanguageCode.es;
            case SiteLanguageCode.us:
                return SiteLanguageCode.us;
            case SiteLanguageCode.en:
                return SiteLanguageCode.us;
            case SiteLanguageCode.br:
                return SiteLanguageCode.br;
            default:
                return SiteLanguageCode.br;
        }
    };
    Object.defineProperty(LanguageService.prototype, "siteLanguage", {
        get: function () {
            var lang = localStorage.getItem('lang');
            if (lang)
                return localStorage.getItem('lang');
            return defaultSiteLanguage;
        },
        enumerable: true,
        configurable: true
    });
    LanguageService.prototype.changeSiteLanguage = function (language) {
        var lang = language.toLowerCase();
        localStorage.setItem('lang', lang);
        this.translateService.use(lang);
    };
    LanguageService.prototype.resetLanguage = function () {
        localStorage.setItem('lang', SiteLanguageCode.br);
    };
    LanguageService.prototype.translate = function (key) {
        return this.translateService.instant(key + '.TRANSLATION');
    };
    LanguageService.prototype.getSiteLanguageCodes = function () {
        return [SiteLanguageCode.es, SiteLanguageCode.us, SiteLanguageCode.br];
    };
    LanguageService.ngInjectableDef = i0.defineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.inject(i1.Router), i0.inject(i2.TranslateService)); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
